import { Component, OnInit} from '@angular/core';
import {TicketsService,EquipmentService} from 'src/app/services/'
import {CreateTicketFormFields,SaveBatchTicket, SelectedBatchEquipment} from 'src/app/models/tickets/createTicketFormFields'
@Component({
  selector: 'bart-electrical-safety',
  templateUrl: './electrical-safety.component.html',
  styleUrls: ['./electrical-safety.component.scss']
})
export class ElectricalSafetyComponent implements OnInit {
  public objElectricalSafty:ElectricalSafty[];
  public formFields:CreateTicketFormFields;
  public objSaveBatchTicket:SaveBatchTicket;
  public errorClass:string="";
  public data: any[];
  public dataSource: any[];
  public totalRecords:number=0;
  cols: any[];
  colsNew: any[];
  users:any[];
  loading = false;
  NextBtnShowHide:boolean=true;
  ModifyBtnShowHide:boolean=false;
  public disabled:boolean=false;
  public btnactive="Next";
  public errorHeader:string="";
  public errorContent:string="";
  public displayError:boolean=false;
  public NoticeDiv:boolean=false;
  
  public btnModifyClicked()
  {
    this.btnactive="Next"
    this.NextBtnShowHide=true;
    this.ModifyBtnShowHide=false;
    this.formFields.isShowBatchLabour=false;
    this.disabled=false;
  }
  public btnBackClicked()
  {
   this.formFields.showCurrentTemplate=false
    }
 public btnNextClicked()
  {
    
   var saveOk = this.AssignData(true);

   if(saveOk)
   { 
     
    
    if(this.objElectricalSafty.length>0)
    { 

      this.btnactive="Modify";
      this.formFields.isShowBatchLabour=true;
      this.NoticeDiv=false;
      this.disabled=true;
    }
    else
    {
      this.btnBackClicked();
    }
    
      
   
   }
   else
   {
     this.NextBtnShowHide=true;
     this.ModifyBtnShowHide=false;
     this.formFields.isShowBatchLabour=false;
      this.disabled=false;
   }

   
  }
 
  constructor(
    private _ticketService:TicketsService,private _equipmentService: EquipmentService,private _ticketsService: TicketsService
  ) {
    this.formFields=new CreateTicketFormFields();
   }

  ngOnInit() 
  {
    
    this._ticketService.getTicketGlobalData().subscribe((Result: any) => {   
      this.formFields=Result;
      this.objElectricalSafty=this.formFields.selectedBatchEquipmentList;
     }, 
     (error) => {
       console.log(error);
     }
   );
   
  }
  
  
  BackBtnShowHide:boolean=true;
 
  btnModifyTemplate()
  {
    this.BackBtnShowHide=true;
    this.NextBtnShowHide=true;
    this.ModifyBtnShowHide=false;
  }
  public RemoveRow(equipmentId:any)
 {
   this.objElectricalSafty=this.objElectricalSafty.filter(x=>x.EquipmentID!=equipmentId);
   this.formFields.selectedBatchEquipmentList=this.objElectricalSafty.filter(x=>x.EquipmentID!=equipmentId);
   if(this.objElectricalSafty.length==0)
    {
      this.formFields.isShowBatchLabour = false;
      this.formFields.selectedBatchEquipmentData=[];

    }
    if(this.formFields.selectedBatchEquipmentData["EquipmentID"]== equipmentId)
    {
     this.formFields.selectedBatchEquipmentData=[];
    }
 }

  public numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
    }
    return true;
  
  }

  public AssignData(showAlert:any)
    {

      this.objSaveBatchTicket=new SaveBatchTicket();
      let success:boolean=true;
      let errors:ElectricalSaftyErrors[]=[];
      this.formFields.batchTicketObj=[]
       var result=true;
       for(let obj of this.objElectricalSafty)
       {
          let equipmentId=obj.EquipmentID;
          let serialNumber =obj.EquipmentSerialNumber;
          let ret =this.checkvalidation(obj);
          if(ret.ElectricalSaftyOk==false)
          {
            errors.push(ret);
            this.NoticeDiv=true;
          }
       }
       if(errors.length==0)
       {
      
        for(let obj of this.objElectricalSafty)
        {
            this.objSaveBatchTicket=new SaveBatchTicket();
            this.objSaveBatchTicket.equipmentId=obj.EquipmentID
            this.objSaveBatchTicket.electricalLeakage=obj.Leakage;
            this.objSaveBatchTicket.groundWireResistance=obj.groundwater;
            if(obj.hasClock==1)
            {
              this.objSaveBatchTicket.clockHours=obj.Machine
            }
           this.formFields.batchTicketObj.push(this.objSaveBatchTicket);
        
        }
        console.log(this.formFields);
      }
      else
      {
        
        success=false;
        this.formFields.batchTicketObj=null;
        
        
          
            this.errorClass="batchError"
          
        
        var errorMsg = '';
        var i = 0;
         for(let x of errors)
         {
          errorMsg += "<div class='errorHeader'>"+x.mainErrorMessage +"</div>";
          for (i=0;i<x.errorMsg.length;i++) 
          {
            errorMsg += x.errorMsg[i] + '<br/>';
          }
         }
         if(showAlert)
         {
           
           //alert (errorMsg);
           this.errorHeader="Validation Error";
           this.errorContent=errorMsg;
           this.displayError=true;
         }
      }
      return success;
        
    }
    public hideErrorDialog()
 {
  this.displayError=false;
 }

public checkvalidation(obj:ElectricalSafty)
 {
    var success=true;
    let ret:ElectricalSaftyErrors = 
    {
      ElectricalSaftyOk:true,
      mainErrorMessage:"",
      errorMsg:[]
    };
      this.objSaveBatchTicket.equipmentId=obj.EquipmentID;
      var Leckage =     obj.Leakage;
      var groundWireResistanceMin:number=null;
      var groundWireResistanceMax:number=null;
      if(obj.groundWireResistanceMax!=null)
      {
        groundWireResistanceMax=obj.groundWireResistanceMax;
      }
      var groundwater=obj.groundwater;

      var machine=obj.Machine;
      var machinehourmin:number=null;
      var machinehourMax:number=null;
      //Start:Added By Harikesh on 23-Oct-2020 for Defect#12398
      let electricalLeakageMin:number=null;
      let electricalLeakageMax:number=null;
      if(obj.electricalLeakageMax!=null)
      {
        electricalLeakageMax=obj.electricalLeakageMax;
      }
       if(this.formFields.batchMeasure!=null &&  this.formFields.batchMeasure.length>0)
       {
         //Pull leakage from batch measure
          let objELeakage=this.formFields.batchMeasure.find(x => x.discreteMeasureAttributeId == 2)
          if(objELeakage!=null && objELeakage.minValue)
          {
            electricalLeakageMin=objELeakage.minValue;
          }
          if(objELeakage!=null && objELeakage.maxValue)
          {
            electricalLeakageMax=objELeakage.maxValue;
          }
       }
      //End:Added By Harikesh on 23-Oct-2020 for Defect#12398

      if (this.formFields.batchMeasure != undefined &&this.formFields.batchMeasure !=null ) 
      {
        let Machinehours = this.formFields.batchMeasure.filter(x => x.discreteMeasureAttributeId == 3);
        if (Machinehours && Machinehours.length > 0)
        {
          
         machinehourmin = Machinehours[0].minValue;
         machinehourMax = Machinehours[0].maxValue;

        }
      }
      if (this.formFields.batchMeasure != undefined &&this.formFields.batchMeasure !=null ) 
      {
        
        let groundwire = this.formFields.batchMeasure.filter(x => x.discreteMeasureAttributeId == 1);
        if (groundwire && groundwire.length > 0) 
        {
          
          groundWireResistanceMax = groundwire[0].maxValue;
          groundWireResistanceMin = groundwire[0].minValue;
         
        }
     }

      
    if (Leckage==undefined|| Leckage=="" || Leckage.length==0) 
    {
      Leckage = null;
    }
    else 
    {
      Leckage = Leckage;
    }
    if (machine ==null||machine==undefined||machine=="") 
    {
      machine = 0;
    }
    else 
    {
      machine = machine;
    }
    if (groundwater==undefined||groundwater=="" || groundwater.length==0) 
    {
      groundwater = null;
    }
    else 
    {
      groundwater = groundwater;
    }
    
    if (Leckage == null) 
    {
      ret.errorMsg.push( 'Electrical Leakage must be entered.');
      ret.ElectricalSaftyOk = false;
    } 
    else if (isNaN(Leckage)) 
    {
     
      ret.errorMsg.push( 'Electrical Leakage must be a numeric value.');
      ret.ElectricalSaftyOk = false;
    } 
    else if (electricalLeakageMin!=null&& Leckage < electricalLeakageMin) 
    {
      ret.errorMsg.push('Electrical Leakage is under advised Minimum.');
      ret.ElectricalSaftyOk = false;
    } 
    else if (electricalLeakageMax!=null&& Leckage > electricalLeakageMax) 
    {
      ret.errorMsg.push('Electrical Leakage exceeds advised Maximum.');
      ret.ElectricalSaftyOk = false;
    } 
    if(groundwater==null)
    {
      
      ret.errorMsg.push( 'Ground Wire Resistance must be entered.');
        ret.ElectricalSaftyOk = false;
    }
    else if(isNaN(groundwater))
    {
      ret.errorMsg.push( 'Ground Wire Resistance must be a numeric vlaue.');
        ret.ElectricalSaftyOk = false;
    }
    else if(groundWireResistanceMin!=null&& groundwater<groundWireResistanceMin)
    {
      ret.errorMsg.push( 'Ground Wire Resistance is under advised Minimum.');
        ret.ElectricalSaftyOk = false;
    }
    else if(groundWireResistanceMax!=null && groundwater>groundWireResistanceMax)
    {
      ret.errorMsg.push( 'Ground Wire Resistance exceeds advised Maximum.');
        ret.ElectricalSaftyOk = false;
    }

   if(obj.hasClock == 1)
   {
      if (isNaN(machine)) 
      {
        ret.errorMsg.push( 'Machine hours must be a number');
        ret.ElectricalSaftyOk = false;
        success=false;
      } 
      if (isNaN(obj.Machine)) 
      {
        ret.errorMsg.push('Machine hours must be a numeric');
        ret.ElectricalSaftyOk = false;
        success=false;
      } 
      else if (!(obj.Machine == parseInt(obj.Machine)) || (machine.indexOf(".")>0)) 
      {
        ret.errorMsg.push( 'Machine Hours must be a number and not contain a decimal.');
        ret.ElectricalSaftyOk = false;
        success=false;
      }
      else if (obj.LastClockHours > machine)
      {
        success=false;
        ret.errorMsg.push( 'Machine hours must be greater than the Last Recorded Hours');
         ret.ElectricalSaftyOk = false;
      }
      else if (machinehourmin != null && machinehourMax != null)
      {
        if (machine < machinehourmin || machine > machinehourMax)
         {
            success=false;
            ret.errorMsg.push( 'Machine hours are not in the correct value range ('+machinehourmin.toString()+'-'+machinehourMax.toString()+').');
            ret.ElectricalSaftyOk = false
         }
      }
    }
    if(ret.ElectricalSaftyOk == false)
    {
      obj.errorClass="batchError"
      ret.mainErrorMessage='Errors found for equipment with serial number ' + obj.EquipmentSerialNumber + '<br/>';
    }
    else
    {
      obj.errorClass="";
    }
    return ret;
  }

    
}
export  class  ElectricalSafty  extends SelectedBatchEquipment{
 
 Machine?:any;
 Leakage?:any;
 groundwater:any;
 errorClass:string=""
}


export class ElectricalSaftyErrors 
{
  ElectricalSaftyOk:boolean;
  mainErrorMessage:string;
  errorMsg:string[]=[];

}